import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/* eslint-env browser */
import React, { useMemo } from 'react';
import ItemsCarousel, { ItemsCarouselWrapper } from '../ItemsCarousel';
import useCarouselState from '../ItemsCarousel/hooks/useCarouselState';
import { useDeviceType, useMediaBreakpoints } from '../../hooks';
import { EMPTY_PROPS } from '../../helpers/types';
import { modifyProps } from '../../helpers/props';
var THRESHOLD = {
  xs: 0.2,
  sm: 0.175,
  md: 0.15,
  lg: 0.125,
  xl: 0.1
};
var TRANSLATE_X_MULTIPLIER = 1.25;
var NUMBER_OF_CARDS = {
  xs: 1.25,
  sm: 1
};
var SLIDES_TO_SCROLL = 1;
var GUTTER = {
  xs: 20,
  sm: 22,
  lg: 24
};
export var ContentCarouselWrapper = ItemsCarouselWrapper;

var ContentCarousel = function ContentCarousel(_ref) {
  var id = _ref.id,
      _ref$withClickPrevent = _ref.withClickPrevention,
      withClickPrevention = _ref$withClickPrevent === void 0 ? true : _ref$withClickPrevent,
      _ref$withNoEventsProp = _ref.withNoEventsPropagation,
      withNoEventsPropagation = _ref$withNoEventsProp === void 0 ? false : _ref$withNoEventsProp,
      _ref$useKeyboardContr = _ref.useKeyboardControl,
      useKeyboardControl = _ref$useKeyboardContr === void 0 ? false : _ref$useKeyboardContr,
      disableDotsClickProp = _ref.disableDotsClick,
      _ref$disableSwipe = _ref.disableSwipe,
      disableSwipeProp = _ref$disableSwipe === void 0 ? false : _ref$disableSwipe,
      _ref$numberOfCards = _ref.numberOfCards,
      numberOfCards = _ref$numberOfCards === void 0 ? NUMBER_OF_CARDS : _ref$numberOfCards,
      _ref$defaultItemIndex = _ref.defaultItemIndex,
      defaultItemIndex = _ref$defaultItemIndex === void 0 ? 0 : _ref$defaultItemIndex,
      itemIndex = _ref.itemIndex,
      onItemIndexChange = _ref.onItemIndexChange,
      onStateChange = _ref.onStateChange,
      _ref$carouselProps = _ref.carouselProps,
      carouselProps = _ref$carouselProps === void 0 ? EMPTY_PROPS : _ref$carouselProps,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$showDots = _ref.showDots,
      showDots = _ref$showDots === void 0 ? true : _ref$showDots,
      _ref$showChevrons = _ref.showChevrons,
      showChevronsProp = _ref$showChevrons === void 0 ? false : _ref$showChevrons,
      _ref$showChevronsOnHo = _ref.showChevronsOnHover,
      showChevronsOnHover = _ref$showChevronsOnHo === void 0 ? false : _ref$showChevronsOnHo,
      _ref$withUserSelectNo = _ref.withUserSelectNone,
      withUserSelectNone = _ref$withUserSelectNo === void 0 ? true : _ref$withUserSelectNo,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "withClickPrevention", "withNoEventsPropagation", "useKeyboardControl", "disableDotsClick", "disableSwipe", "numberOfCards", "defaultItemIndex", "itemIndex", "onItemIndexChange", "onStateChange", "carouselProps", "disabled", "showDots", "showChevrons", "showChevronsOnHover", "withUserSelectNone", "children"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  var threshold = useMediaBreakpoints(THRESHOLD);
  var disableDotsClick = useMemo(function () {
    return disableDotsClickProp != null ? disableDotsClickProp : hasTouchScreen;
  }, [disableDotsClickProp, hasTouchScreen]);
  var disableSwipeDefault = useMemo(function () {
    return modifyProps(showChevronsProp, function (showChevrons) {
      return showChevrons && !hasTouchScreen;
    });
  }, [showChevronsProp, hasTouchScreen]);
  var disableSwipe = useMediaBreakpoints(disableSwipeProp != null ? disableSwipeProp : disableSwipeDefault);

  var _useCarouselState = useCarouselState({
    children: children,
    numberOfCards: numberOfCards,
    itemIndex: itemIndex,
    defaultItemIndex: defaultItemIndex,
    onItemIndexChange: onItemIndexChange,
    onStateChange: onStateChange,
    useKeyboardControl: useKeyboardControl,
    disabled: disabled,
    slidesToScroll: SLIDES_TO_SCROLL
  }),
      index = _useCarouselState.index,
      setActiveIndex = _useCarouselState.setActiveIndex;

  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(ItemsCarousel, _extends({
    id: id,
    disabled: disabled,
    threshold: threshold,
    onActiveItemIndexChange: setActiveIndex,
    activeItemIndex: index,
    numberOfCards: numberOfCards,
    gutter: GUTTER,
    showChevrons: showChevronsProp,
    showChevronsOnHover: showChevronsOnHover,
    withOutsideChevrons: false,
    withOverflowHidden: false,
    withUserSelectNone: withUserSelectNone,
    withNoEventsPropagation: withNoEventsPropagation,
    withClickPrevention: withClickPrevention,
    showDots: showDots,
    disableChangeOnDotsClick: disableDotsClick,
    disableSwipe: disableSwipe,
    translateXMultiplier: TRANSLATE_X_MULTIPLIER,
    slidesToScroll: SLIDES_TO_SCROLL
  }, carouselProps), children));
};

export default ContentCarousel;